import { FC, ReactNode } from 'react'
import { Grid, IButtonProps, Icon, Modal } from '@aurecon-creative-technologies/styleguide'

import Style from '../styles/CommonModals.module.sass'
import classNames from 'classnames'

interface LeaveModalProps {
  title: string
  message: string | ReactNode
  open: boolean
  loading?: boolean
  onYes?: () => void
  onNo?: () => void
  onClose: () => void
  labelYes?: string
  labelClose?: string
  size?: 'small' | 'medium' | 'large'
  isCloseButton?: boolean
  cssClass?: string
  titleIcon?: string
}

const LeaveModal: FC<LeaveModalProps> = (props) => {
  const actions: IButtonProps[] = [
    {
      type: 'secondary',
      label: props.labelClose ?? 'No',
      disabled: props.loading,
      cssClass: Style.secondaryButton,
      onClick: () => (props.onNo ? props.onNo() : props.onClose()),
    },
    {
      type: 'primary',
      label: props.labelYes ?? 'Yes',
      cssClass: Style.primaryButton,
      loading: props.loading,
      disabled: props.loading,
      onClick: props?.onYes,
    },
  ]

  return (
    <Modal
      isShowing={props.open}
      shouldOverlayClose={false}
      isOverlay
      isCloseButton={props.isCloseButton}
      modalPadding={{ top: '24px', right: '24px', left: '24px', bottom: '24px' }}
      onClose={props.onClose}
      actions={actions}
      cssClass={classNames(Style.commonModal, props?.cssClass)}
      size={props.size ?? 'medium'}
    >
      <Grid row cssClass={Style.modalContainer}>
        <Grid item xs={12} cell>
          <h2>
            {props.titleIcon && <Icon type={props.titleIcon} className={Style.LeaveModalIcon} />}
            {props.title}
          </h2>
          <span className={Style.message}>{props.message}</span>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default LeaveModal
